<template>
    <div class="columns is-centered">
        <section class="column is-half section">

            <checkout-step1 :step="step" @valid="onStep1Valid" :data="step1" @edit="step = 1"></checkout-step1>

            <checkout-step2 :step="step" @valid="onStep2Valid" :data="step2" @edit="step = 2"></checkout-step2>

            <checkout-step3 :step="step" @valid="onStep3Valid" :data="step3" @edit="step = 3"></checkout-step3>
        
            <checkout-step4 :step="step" @valid="onStep4Valid" :data="step4" @edit="step = 4"></checkout-step4>

            <checkout-step5 :step="step" @valid="onStep5Valid" :data="allData"></checkout-step5>

            <span v-if="hasError" style="font-size: 12px; text-align: center; color: red">We are sorry an error occurred. Please contact the number below on the footer for your order.</span>
    
        </section>
    </div>
</template>

<script>
import { Validator } from 'vee-validate';
import CheckoutStep from './CheckoutStep';
import BInput from 'buefy/src/components/input/Input';
import BSelect from 'buefy/src/components/select/Select';
import BField from 'buefy/src/components/field/Field';

import CheckoutStep1 from './checkout-steps/CheckoutStep1';
import CheckoutStep2 from './checkout-steps/CheckoutStep2';
import CheckoutStep3 from './checkout-steps/CheckoutStep3';
import CheckoutStep4 from './checkout-steps/CheckoutStep4';
import CheckoutStep5 from './checkout-steps/CheckoutStep5';

export default {
  components: {

    CheckoutStep1,
    CheckoutStep2,
    CheckoutStep3,
    CheckoutStep4,
    CheckoutStep5,

    BField,
    BSelect,
    BInput,
    CheckoutStep,
  },

  name: 'checkout',

  data() {
    return {
      step: 1,
      hasError: false,

      // recipient
      step1: {
        delivery_date: '',
        recipient_fname: '',
        recipient_lname: '',
        
        address: '',
        city: '',
        province: 'MB',
        postal_code: '',
        country: 'CA',
        
        recipient_cell: '',
        recipient_phone: '',
        recipient_email: '',
      },

      // card message + special instructions
      step2: {
        card_message: '',
        special_instructions: '',
      },

      // sender details
      step3: {
        sender_fname: '',
        sender_lname: '',

        sender_cell: '',
        sender_phone: '',
        sender_email: '',
      },

      // payment
      step4: {
        pay_by_phone: false,

        card_number: '',
        expiry_year: '',
        expiry_month: '',
        cvc: '',
      },
      

    };
  },

  methods: {
    edit(step) {
      this.step = step;
    },

    onStep1Valid() {
      this.step++;
    },

    onStep2Valid() {
      this.step++;
    },

    onStep3Valid() {
      this.step++;
    },

    onStep4Valid() {
      this.step++;
    },


    onStep5Valid() {
      this.$toast.open('Order Confirmed');

      let data = Object.assign({}, this.step1, this.step2, this.step3, this.step4);

      this.$store.dispatch('order/confirm', data).then(response => {

        this.$store.dispatch('cart/load').then(response => {
          this.$router.replace('/thanks');

        }, error => {
          console.error("2");
          console.log(error);
          this.hasError = true;
        });
      
      }, error => {
        console.error("1");
        console.log(error);
        this.hasError = true;
      });

    },

    fillFromUser() {
      if (this.user !== null) {
        this.step3.sender_email = this.user.email;
      }
    },
  },

  computed: {
    user() {
      return this.$store.state.auth.user;
    },

    allData() {
      return {
        step1: this.step1,
        step2: this.step2,
        step3: this.step3,
        step4: this.step4,
      };
    },
  },

  mounted() {
    this.fillFromUser();
  },

  watch: {
    user() {
      this.fillFromUser();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue